import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import logo from "../../assets/spectrack.png";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingBtn from "../../components/LoadingBtn/LoadingBtn";
import { dynamicTheme } from "../../utils/dynamicTheme";

function Login() {
  const { tenant } = useParams();           // 👈 get tenant from URL
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [tenantLoading, setTenantLoading] = useState(true);
  const [tenantValid, setTenantValid] = useState(false);

  /* ------------------------------------
     TENANT VALIDATION (ON PAGE LOAD)
  -------------------------------------*/
  useEffect(() => {
    const validateTenant = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/public/tenant/${tenant}`
        );

        if (res.data?.status && res.data?.responseCode === 200) {
        const { tenant: tenantName, theme } = res.data.response;

        // sessionStorage.setItem("tenantId", res.data.tenantId);
        sessionStorage.setItem("tenant", tenantName);
        sessionStorage.setItem("tenantTheme", JSON.stringify(theme));
        dynamicTheme(theme);
        setTenantValid(true);
        } else {
          navigate("/404", { replace: true });
        }
      } catch (error) {
        navigate("/404", { replace: true });
      } finally {
        setTenantLoading(false);
      }
    };

    validateTenant();
  }, [tenant, navigate]);

  /* ------------------------------------
     LOGIN HANDLER
  -------------------------------------*/
  const sha256Hex = async (message) => {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    const hashedPassword = await sha256Hex(password);

    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
        email,
        password: hashedPassword,
        tenant: sessionStorage.getItem("tenant") // 👈 send tenantId
      })
      .then((res) => {
        if (res.data.response && res.data.responseCode === 200) {
          sessionStorage.setItem("token", res.data.response.access_token);
          sessionStorage.setItem("role", res.data.response.role);
          sessionStorage.setItem("username", res.data.response.username);
          sessionStorage.setItem("email", res.data.response.email);

          navigate("/dashboard");
        }
      })
      .catch((err) => {
        let message = "Login failed";
        if (err.response?.data?.message) {
          message = err.response.data.message;
        }
        toast.error(message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  /* ------------------------------------
     LOADING STATE (Tenant Validation)
  -------------------------------------*/
  if (tenantLoading) {
    return (
      <div className="vh-100 d-flex justify-content-center align-items-center">
        <h4 style={{ color: "#2a2e5e" }}>Loading...</h4>
      </div>
    );
  }

  if (!tenantValid) return null;

  /* ------------------------------------
     LOGIN UI
  -------------------------------------*/
  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{ backgroundColor: "#2a2e5e" }}
    >
      <div
        className="blur-box card shadow-lg p-2 d-flex flex-column align-items-center"
        style={{
          height: "500px",
          width: "450px",
          borderRadius: "20px",
          background: "linear-gradient(to bottom left , #5538AB, #386ED0)",
          color: "white",
        }}
      >
        <img src={logo} alt="Logo" style={{ height: "130px" }} />

        <h3 className="mb-1 mt-5">Sign In</h3>
        <p className="mb-4" style={{ fontSize: "14px" }}>
          Your Account
        </p>

        <form onSubmit={handleLogin} className="d-flex flex-column align-items-center">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              height: "55px",
              width: "270px",
              borderRadius: "10px",
              padding: "0 15px",
              marginBottom: "15px",
              border: "none",
            }}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              height: "55px",
              width: "270px",
              borderRadius: "10px",
              padding: "0 15px",
              marginBottom: "20px",
              border: "none",
            }}
          />

          <LoadingBtn text="Login" loading={loading} type="submit" />
        </form>
      </div>
    </div>
  );
}

export default Login;
